import { Component, OnInit } from '@angular/core';
import * as numeral from 'numeral';

@Component({
	selector: 'comprobante-list',
	templateUrl: './comprobante-list.component.html',
	styleUrls: ['./comprobante-list.component.css'],
})
export class ComprobanteListComponent implements OnInit {
	public dataGrid: any;

	constructor() {
		this.dataGrid = {
			keyGrid: "comprobante",
			perPage: 10,
			endPoint: "/comprobantes",
			routeEdit: "/ventas/comprobantes-edit",
			hideButtonDel: true,
			qs: "&embed=caja?emdeb=sucursal,tipocomprobante",
			columsn: [
				{
					Col: [
						{
							Header: "Sucursal",
							Colspan: 2
						},
						{
							Header: "Caja",
							Colspan: 2
						}
					]
				},
				{
					Col: [
						{
							Header: "Nombre",
							Field: "caja.sucursal.nombre"
						},
						{
							Header: "Establecimiento",
							Field: "caja.sucursal.establecimiento"
						}
					]
				}
			],

			columsDef: [
				/*{
					Hearder: "Sucursal",
					Colspan: 2,
					Field: [
						{
							Header: "Nombre",
							Field: "caja.sucursal.nombre",
							Rowspan: 2
						},
						{
							Header: "Establecimiento",
							Field: "caja.sucursal.establecimiento",
							Rowspan: 2
						}
					]
				},*/

				{
					Header: "Sucursal",
					Field: "caja.sucursal.nombre"
				},
				{
					Header: "Caja",
					Field: "caja.nombre"
				},
				{
					Header: "Establecimiento",
					Field: "caja.sucursal.establecimiento"
				},
				{
					Header: "Punto de emisión",
					Field: "caja.punto_emision"
				},
				{
					Header: "Tipo",
					Field: "tipocomprobante.nombre"
				},
				{
					Header: "Secuencial",
					Field: "secuencial",
					Searchable: true,
				}
			]
		};
	}

	ngOnInit() {
		//
	}
}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/comprobante-list/comprobante-list.component.ts